"use client";

import { BookOpen, CalendarCheck, Sparkles } from "lucide-react";
import {
  StaggerContainer,
  StaggerItem,
} from "@/components/shared/StaggerContainer";

const PROOF_ITEMS = [
  { icon: CalendarCheck, text: "One clear thing to do each day" },
  { icon: BookOpen, text: "Based on peer-reviewed neuroscience" },
  { icon: Sparkles, text: "5 personalization areas" },
];

export function SocialProofBar() {
  return (
    <section className="border-y border-border bg-muted/50">
      <StaggerContainer
        className="mx-auto flex max-w-7xl justify-center px-4 py-10 sm:px-6 sm:py-14"
        stagger={0.1}
      >
        {/* On mobile the three rows share ONE left edge as a centered block —
            individually-centered rows of different widths read as ragged. */}
        <div className="flex flex-col items-start gap-5 sm:flex-row sm:items-center sm:gap-16">
          {PROOF_ITEMS.map((item) => (
            <StaggerItem
              key={item.text}
              className="flex items-center gap-2.5 text-muted-foreground"
            >
              <item.icon className="h-6 w-6 shrink-0 text-primary" />
              <span className="text-base font-medium sm:text-lg">{item.text}</span>
            </StaggerItem>
          ))}
        </div>
      </StaggerContainer>
    </section>
  );
}
